"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentExpiration = exports.DbCollections = exports.EntityCustomFieldType = exports.SalesChannelType = exports.supportedProviders = exports.ProviderActivityTypes = exports.dashboard_pages = exports.payableRecurringStatues = exports.payablePaymentStatuses = exports.ProviderIdentificationType = exports.PayableEntityType = exports.OwnerTypes = exports.CreateEntities = exports.Long = void 0;
const payment_types_1 = require("./payment-types");
const recurring_payments_types_1 = require("./recurring-payments-types");
const long_1 = require("./long");
Object.defineProperty(exports, "Long", { enumerable: true, get: function () { return long_1.Long; } });
var CreateEntities;
(function (CreateEntities) {
    CreateEntities["USER"] = "User";
    CreateEntities["API_KEY"] = "ApiKey";
    CreateEntities["EXTERNAL_INTEGRATION"] = "ExternalIntegration";
    CreateEntities["SYSTEM"] = "System";
    CreateEntities["ACCOUNTING_SOFTWARE"] = "AccountingSoftware";
    CreateEntities["EXTERNAL_APP"] = "ExternalApp";
})(CreateEntities = exports.CreateEntities || (exports.CreateEntities = {}));
var OwnerTypes;
(function (OwnerTypes) {
    OwnerTypes["COMPANY"] = "Company";
    OwnerTypes["CONSUMER"] = "Consumer";
    OwnerTypes["SYSTEM"] = "System";
})(OwnerTypes = exports.OwnerTypes || (exports.OwnerTypes = {}));
var PayableEntityType;
(function (PayableEntityType) {
    PayableEntityType["PAYMENT"] = "Payment";
    PayableEntityType["RECURRING_PAYMENT"] = "RecurringPayment";
    PayableEntityType["BULK_PAYMENT"] = "BulkPayment";
    PayableEntityType["VRP"] = "VrpPayment";
})(PayableEntityType = exports.PayableEntityType || (exports.PayableEntityType = {}));
var ProviderIdentificationType;
(function (ProviderIdentificationType) {
    ProviderIdentificationType["SORT_CODE_ACCOUNT_NUMBER"] = "SORT_CODE_ACCOUNT_NUMBER";
    ProviderIdentificationType["IBAN"] = "IBAN";
    ProviderIdentificationType["IBAN_SWIFT"] = "IBAN_SWIFT";
})(ProviderIdentificationType = exports.ProviderIdentificationType || (exports.ProviderIdentificationType = {}));
exports.payablePaymentStatuses = [
    payment_types_1.PaymentStatus.OVERDUE,
    payment_types_1.PaymentStatus.SENT,
    payment_types_1.PaymentStatus.REJECTED,
];
exports.payableRecurringStatues = [
    recurring_payments_types_1.RecurringPaymentStatus.SENT,
    recurring_payments_types_1.RecurringPaymentStatus.REJECTED,
];
var dashboard_pages;
(function (dashboard_pages) {
    dashboard_pages["BUISNESS_DETAILS"] = "/dashboard/settings/business-details/";
    dashboard_pages["BANK_ACCOUNT_SETTINGS"] = "/dashboard/settings/bank-account/";
    dashboard_pages["SUMSUB_VERIFY"] = "/verify/";
    dashboard_pages["EMAIL_VERIFICATION"] = "/register/email-verification-start/";
    dashboard_pages["LOGIN"] = "/login/";
    dashboard_pages["RECURRING_PAYMENTS"] = "/dashboard/payment/recurring/";
})(dashboard_pages = exports.dashboard_pages || (exports.dashboard_pages = {}));
var ProviderActivityTypes;
(function (ProviderActivityTypes) {
    ProviderActivityTypes["DATA_API"] = "dataApi";
    ProviderActivityTypes["SINGLE_DOMESTIC_PAYMENT"] = "singleDomesticPayment";
    ProviderActivityTypes["SINGLE_FOREIGN_PAYMENT"] = "singleForeignPayment";
    ProviderActivityTypes["BULK_DOMESTIC_PAYMENT"] = "bulkDomesticPayment";
    ProviderActivityTypes["BULK_FOREIGN_PAYMENT"] = "bulkForeignPayment";
    ProviderActivityTypes["RECURRING_DOMESTIC_PAYMENT"] = "recurringDomesticPayment";
    ProviderActivityTypes["RECURRING_FOREIGN_PAYMENT"] = "recurringForeignPayment";
    ProviderActivityTypes["VARIABLE_RECURRING_DOMESTIC_PAYMENT"] = "variableRecurringDomesticPayment";
    ProviderActivityTypes["VARIABLE_RECURRING_FOREIGN_PAYMENT"] = "variableRecurringForeignPayment";
    ProviderActivityTypes["RECEIVE_FUNDS_ONLY"] = "receiveFundsOnly";
    /**
     * Bank can accept a payer account pinned by the merchant ("Specified bank account").
     * UK banks take it as sort code + account number; EU banks as a `debtor_iban` the
     * catalogue lists among their required/supported payment fields.
     */
    ProviderActivityTypes["SPECIFIC_BANK_ACCOUNT"] = "specificBankAccount";
})(ProviderActivityTypes = exports.ProviderActivityTypes || (exports.ProviderActivityTypes = {}));
/**
 * Providers that support recurring payment status updates
 */
exports.supportedProviders = [
    "ob-sandbox-lloyds",
    "ob-lloyds-personal",
    "ob-barclays-personal",
    "ob-barclays-business",
    "ob-revolut",
    "ob-santander",
    "ob-halifax-personal",
    "ob-natwest",
    "ob-tsb",
    "ob-hsbc-personal",
    "ob-hsbc-business",
    "ob-bos-personal",
    "ob-lloyds-business",
    "ob-bos-business",
    "ob-monzo",
    "ob-virgin-money",
    "ob-first-direct",
    "ob-rbs",
    "ob-ulster",
    "starling",
    //  "ob-nationwide" doesn't support references
];
var SalesChannelType;
(function (SalesChannelType) {
    SalesChannelType["EXTERNAL_APP"] = "ExternalApp";
    SalesChannelType["EXTERNAL_INTEGRATION"] = "ExternalIntegration";
    SalesChannelType["ACCOUNTING_SOFTWARE"] = "AccountingSoftware";
})(SalesChannelType = exports.SalesChannelType || (exports.SalesChannelType = {}));
var EntityCustomFieldType;
(function (EntityCustomFieldType) {
    /** for amount like fields 1.00 ,20.35 etc*/
    EntityCustomFieldType["AMOUNT"] = "amount";
    EntityCustomFieldType["NONE"] = "none";
})(EntityCustomFieldType = exports.EntityCustomFieldType || (exports.EntityCustomFieldType = {}));
var DbCollections;
(function (DbCollections) {
    DbCollections["ACCOUNTING_SOFTWARES"] = "accountingsoftwares";
    DbCollections["ADDRESSES"] = "addresses";
    DbCollections["API_KEYS"] = "apikeys";
    DbCollections["API_TOKENS"] = "apitokens";
    DbCollections["ATTACHMENTS"] = "attachments";
    DbCollections["BANK_ACCOUNTS"] = "bankaccounts";
    DbCollections["BRANDS"] = "brands";
    DbCollections["BULK_PAYMENTS"] = "bulkpayments";
    DbCollections["CATEGORIES"] = "categories";
    DbCollections["COMPANIES"] = "companies";
    DbCollections["COMPANY_OFFICERS"] = "companyofficers";
    DbCollections["COMPANY_SETTINGS"] = "companysettings";
    DbCollections["CUSTOMERS"] = "customers";
    DbCollections["CONSUMERS"] = "consumers";
    DbCollections["DOCUMENT_ATTACHMENTS"] = "documentattachments";
    DbCollections["EMAIL_CUSTOMISATION_SETTINGS"] = "emailcustomisationsettings";
    DbCollections["EXTERNAL_INTEGRATIONS"] = "externalintegrations";
    DbCollections["HISTORY_ENTRIES"] = "historyentries";
    DbCollections["IMAGE_ATTACHMENTS"] = "imageattachments";
    DbCollections["NOTES"] = "notes";
    DbCollections["ORDERS"] = "orders";
    DbCollections["PAYEE_ACCOUNTS"] = "payeeaccounts";
    DbCollections["PAYMENTS"] = "payments";
    DbCollections["PRODUCTS"] = "products";
    DbCollections["PROVIDERS"] = "providers";
    DbCollections["RECURRING_PAYMENTS"] = "recurringpayments";
    DbCollections["ROLES"] = "roles";
    DbCollections["SUPPLIERS"] = "suppliers";
    DbCollections["SYSTEMS"] = "systems";
    DbCollections["TRANSACTIONS"] = "transactions";
    DbCollections["USERS"] = "users";
    DbCollections["SHIPMENTS"] = "shipments";
    DbCollections["BUNDLE_VARIANTS"] = "bundlevariants";
    DbCollections["PRODUCT_VARIANTS"] = "productvariants";
    DbCollections["PRODUCT_OPTIONS"] = "productoptions";
    DbCollections["EXTERNAL_APPS"] = "externalapps";
    DbCollections["LOCATIONS"] = "locations";
    DbCollections["SEGMENTS"] = "segments";
    DbCollections["INVENTORY_ORDERS"] = "inventoryorders";
    DbCollections["LOGS"] = "logs";
    DbCollections["ORDER_PRODUCTS"] = "orderproducts";
    DbCollections["INVENTORY_ORDER_PRODUCTS"] = "inventoryorderproducts";
    DbCollections["COMMERCIAL_INVOICES"] = "commercialinvoices";
    DbCollections["INVOICES"] = "invoices";
    DbCollections["SUBSCRIPTION_EXTENSION_PACKS"] = "subscriptionextensionpacks";
    DbCollections["SUBSCRIPTION_AFFILIATIONS"] = "subscriptionaffiliations";
    DbCollections["MANAGED_COMPANY_INTEGRATIONS"] = "managedcompanyintegrations";
    DbCollections["MANIFESTS"] = "manifests";
    DbCollections["MOBILE_SETTINGS"] = "mobilesettings";
    DbCollections["COMPANY_STRIPE_DATA"] = "companystripedatas";
    DbCollections["COMPANY_LIMITS"] = "companylimits";
    DbCollections["COMPANY_STRIPE_USAGE_DATA"] = "companystripeusagedatas";
    DbCollections["COMPANY_SUBSCRIPTIONS"] = "companysubscriptions";
    DbCollections["COMPANY_STRIPE_SUBSCRIPTION_EVENTS"] = "companystripesubscriptionevents";
})(DbCollections = exports.DbCollections || (exports.DbCollections = {}));
var ConsentExpiration;
(function (ConsentExpiration) {
    ConsentExpiration["DAY_30"] = "day-30";
    ConsentExpiration["DAY_14"] = "day-14";
    ConsentExpiration["DAY_1"] = "day-1";
    ConsentExpiration["EXPIRED"] = "expired";
    ConsentExpiration["UP_TO_DATE"] = "up-to-date";
})(ConsentExpiration = exports.ConsentExpiration || (exports.ConsentExpiration = {}));
